import React from "react";

export default function Placeholder({ label = "CONTENT PENDING", children }) {
  return (
    <span className="placeholder-tag" data-testid="placeholder">
      [PLACEHOLDER] {children || label}
    </span>
  );
}
